import Mirador from '@etu/chinese-mirador';
// import textOverlayPlugin from '@etu/mirador-textoverlay';
import { miradorImageToolsPlugin } from '@etu/mirador-image-tools';
import plugins from './plugins';
global.Mirador = Mirador;
global.miradorImageToolsPlugin = miradorImageToolsPlugin;
// global.textOverlayPlugin = textOverlayPlugin;
// import helpButtonPlugin from './plugins/';




